/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Origin_Chat_ActivityInputs */



/**
* | output |
* | --- |
* | "Chat Activity" |
*
* @param {Audit_Origin_Chat_ActivityInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_origin_chat_activity = /** @type {((inputs?: Audit_Origin_Chat_ActivityInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Origin_Chat_ActivityInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Chat-Aktivität")
	return /** @type {LocalizedString} */ ("Chat Activity")
});